import { createTheme } from '@mui/material/styles';

const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
  },
};

const theme = createTheme({
  breakpoints,
  palette: {
    mode: "light",
    primary: {
      main: "#1a3a6f",
      light: "#2a4a8f",
      dark: "#0a2a5f",
    },
    secondary: {
      main: "#4a7bff",
      contrastText: "#ffffff",
    },
    background: {
      default: "#f8f9fa",
      paper: "#ffffff",
    },
  },
  typography: {
    fontFamily: ["Inter", "sans-serif"].join(","),
    h1: {
      fontWeight: 800,
      fontSize: "3.5rem",
      letterSpacing: "-0.02em",
      color: "#1a3a6f",
      [breakpoints.values.md]: {
        fontSize: "2.5rem",
      },
      [breakpoints.values.sm]: {
        fontSize: "2rem",
      },
    },
    h2: {
      fontWeight: 700,
      fontSize: "2.5rem",
      letterSpacing: "-0.015em",
      color: "#1a3a6f",
      [breakpoints.values.md]: {
        fontSize: "2rem",
      },
      [breakpoints.values.sm]: {
        fontSize: "1.75rem",
      },
    },
    h3: {
      fontWeight: 700,
      fontSize: "2rem",
      letterSpacing: "-0.01em",
      color: "#1a3a6f",
      [breakpoints.values.sm]: {
        fontSize: "1.5rem",
      },
    },
    h4: {
      fontWeight: 700,
      fontSize: "1.5rem",
      color: "#1a3a6f",
      [breakpoints.values.sm]: {
        fontSize: "1.25rem",
      },
    },
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
    body1: {
      color: "#4a5568",
      [breakpoints.values.sm]: {
        fontSize: "0.875rem",
      },
    },
    body2: {
      color: "#718096",
      [breakpoints.values.sm]: {
        fontSize: "0.875rem",
      },
    },
    h6: {
      [breakpoints.values.sm]: {
        fontSize: "1rem",
      },
    },
  },
  
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          padding: "10px 24px",
          boxShadow: "none",
          "&:hover": {
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          },
          [breakpoints.values.sm]: {
            padding: "8px 16px",
            fontSize: "0.875rem",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "16px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
          transition: "all 0.3s ease",
          background: "#ffffff",
          "&:hover": {
            transform: "translateY(-8px)",
            boxShadow: "0 12px 32px rgba(74, 123, 255, 0.2)",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            background: "#ffffff",
          },
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(74, 123, 255, 0.2)",
        },
      },
    },
  },
});

export default theme;